import { Controller } from "@hotwired/stimulus"

// Clears marketing/conference checkboxes when contact status is set to Inactive.
export default class extends Controller {
  static targets = ["marketing", "conferences"]

  changed(event) {
    if (event.target.value === "Inactive") {
      this.marketingTarget.checked = false
      this.conferencesTarget.checked = false
    }
  }
}
